import React from 'react';
import {defaultSerializers} from '@sanity/block-content-to-react';
import {Link} from 'gatsby';

export default {
	types: {
		block: props => defaultSerializers.types.block(props)
	},
	marks: {
		link: props => {
			if (props.mark.href[0] === '/') {
				return (
					<Link
						title={props.mark.title}
						target={props.mark.openInNewWindow ? '_blank' : null}
						to={props.mark.href}>
						{props.children}
					</Link>
				);
			}
			return (
				<a
					title={props.mark.title}
					target={props.mark.openInNewWindow ? '_blank' : null}
					href={props.mark.href}>
					{props.children}
				</a>
			);
		}
	}
};